import { request } from "./http";

// ---- Custom domains -----------------------------------------------------

export interface CustomDomain {
  id: string;
  domain: string;
  status: "pending" | "active" | "suspended";
  ssl_status: "pending" | "active";
  dns_validation_token: string | null;
  dns_validation_record: string | null;
  verified_at: string | null;
  created_at: string;
}

export const customDomains = {
  list: () => request<CustomDomain[]>("/api/v1/custom-domains"),
  register: (domain: string) =>
    request<CustomDomain>("/api/v1/custom-domains", { body: { domain } }),
  delete: (domain: string) =>
    request<void>(`/api/v1/custom-domains/${encodeURIComponent(domain)}`, { method: "DELETE" }),
  verify: (domain: string) =>
    request<CustomDomain>(`/api/v1/custom-domains/${encodeURIComponent(domain)}/verify`, {
      method: "POST",
    }),
};

// ---- Usage --------------------------------------------------------------

export interface UsageBucket {
  event_type: string;
  quantity: string;
  unit: string;
  count: number;
}
export interface UsagePeriod {
  from: string;
  to: string;
  buckets: UsageBucket[];
}
export interface UsageEventRow {
  id: number;
  event_type: string;
  quantity: string;
  unit: string;
  occurred_at: string;
  metadata: Record<string, unknown>;
}

export const usage = {
  summary: (params?: { from?: string; to?: string; event_type?: string }) => {
    const qs = new URLSearchParams();
    if (params?.from) qs.set("from", params.from);
    if (params?.to) qs.set("to", params.to);
    if (params?.event_type) qs.set("event_type", params.event_type);
    return request<UsagePeriod>(`/api/v1/usage${qs.toString() ? "?" + qs : ""}`);
  },
  events: (params?: { from?: string; to?: string; event_type?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params?.from) qs.set("from", params.from);
    if (params?.to) qs.set("to", params.to);
    if (params?.event_type) qs.set("event_type", params.event_type);
    if (params?.limit) qs.set("limit", String(params.limit));
    return request<UsageEventRow[]>(`/api/v1/usage/events${qs.toString() ? "?" + qs : ""}`);
  },
};
